import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { testimonials } from "../components/layout/data";   
import "swiper/css/navigation";
import "./TestimonialSlider.css";

export default function TestimonialSlider() {
  return (
  <div className="testimonial-section-bg"> {/* full width background */}
  <div className="testimonial-section"> {/* centered content */}
    <h2>Hear from our members</h2>

    <Swiper
      modules={[Navigation]}
      spaceBetween={50}
      slidesPerView={4}
      navigation
      loop={false}
      breakpoints={{
        320: { slidesPerView: 1, spaceBetween: 30 },
        640: { slidesPerView: 2, spaceBetween: 40 },
        1024: { slidesPerView: 3, spaceBetween: 50 },
        1440: { slidesPerView: 4, spaceBetween: 50 },
      }}
    >
      {testimonials.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="testimonial-card">
            <div className="testimonial-media">
              {item.video ? (
                <video controls src={item.video} />
              ) : (
                <img src={item.img} alt={item.name} />
              )}
            </div>
            <div className="testimonial-info">
              <h4>{item.name}</h4>
              <p>{item.text}</p>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
</div>
  );
}